import useDialogStore from 'stores/dialogStore';

/** React에서 다이얼로그를 여는 진입점. 목록 변경은 구독하지 않는다. */
const useDialog = () => {
  const open = useDialogStore((state) => state.open);

  return { open };
};

export default useDialog;
